export function generateCSV(minutelyProbabilities, userMoments = []) {
  const momentsByTs = new Map();
  for (const m of userMoments) {
    momentsByTs.set(m.timestamp, m.note || '');
  }

  const headers = ['Timestamp (Unix)', 'Date (EST)', 'Probability (%)', 'User Note'];
  const rows = minutelyProbabilities.map((point) => {
    const note = momentsByTs.get(point.timestamp) || '';
    return [
      point.timestamp,
      point.date,
      (point.probability * 100).toFixed(2),
      `"${note.replace(/"/g, '""')}"`,
    ].join(',');
  });

  return [headers.join(','), ...rows].join('\n');
}

export function downloadCSV(csvContent, filename = 'polyvideo-data.csv') {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
